import clsx from "clsx";
import { useContext } from "react";

import { NewsContext } from "@";
import * as components from "@components";
import { MostRecent, AllInsights } from "./components";

const metaProps = {
    title: "News and updates on global forest carbon from CTrees",
    desc: "CTrees’ data products, science, and partnerships to protect and restore forests are constantly evolving. Learn more about our work.",
    img: "",
};

export default function News() {
    const { articles } = useContext(NewsContext);

    // Option 1: Select specific articles by URI
    const featuredArticleUris = [
        "study-congo-basin-carbon-change",
        "2026-aboveground-biomass-data-release",
        "indonesia-flood-risk-analysis",
        "seeing-the-forest-and-the-trees",
        "mapping-urban-canopies-100-cities",
    ];

    const featured = articles?.filter(article =>
        featuredArticleUris.includes(article.uri)
    ).slice(0, 5);

    // Get the most recent article by publish_date
    const mostRecentArticle = articles?.sort((a, b) =>
        new Date(b.publish_date) - new Date(a.publish_date)
    )[0];

    // Option 2: Keep original behavior (first 5 articles)
    // const featured = articles?.slice(0, 5);

    const cards = featured.map((item, i) => {
        return {
            date: item.publish_date,
            img: item.image_url,
            imgAlt: item.title,
            title: item.title,
            subheader: item.summary,
            link: item.uri,
            tags: item.product_tags.concat(item.article_tags),
        };
    });

    return (
        <>
            <components.MetaTagHeader {...metaProps} />
            <div className="flex w-full justify-center">
                <div className={containerStyle}>
                    {/* Featured Article */}
                    <MostRecent article={mostRecentArticle} />

                    {/* Featured Articles */}
                    <div className="mb-10 w-full text-2xl font-bold">
                        Featured Articles
                    </div>

                    <components.CarouselCards cards={cards} />
                    <components.DottedDivider className="mb-10 w-full lg:hidden" />
                    <AllInsights articles={articles} />
                </div>
            </div>

            <components.StayConnected />
        </>
    );
}

const containerStyle = clsx(
    "mb-10 mt-16 flex w-[90%] flex-col items-center lg:mb-40 mt-24",
);
